export const initialBatches = [
  {
    id: "BAT-2026-001",
    batchNo: "SM-2601-HYD",
    productId: "PROD-001",
    productName: "BPT 5204 Premium Sona Masoori Raw Rice (25kg Bag)",
    mfgDate: "2026-01-10",
    expiryDate: "2027-01-09",
    qtyRemaining: 145,
    warehouseId: "WH-001",
    warehouseCode: "WH-KATTEDAN",
    binCode: "A1-S1-B1",
    unitCost: 1320,
    mrp: 1650,
    status: "Good"
  },
  {
    id: "BAT-2026-002",
    batchNo: "DZ-2602-HYD",
    productId: "PROD-002",
    productName: "Daawat Rozana Super Basmati Rice (5kg Bag)",
    mfgDate: "2026-02-15",
    expiryDate: "2027-02-14",
    qtyRemaining: 110,
    warehouseId: "WH-001",
    warehouseCode: "WH-KATTEDAN",
    binCode: "A2-S1-B1",
    unitCost: 360,
    mrp: 480,
    status: "Good"
  },
  {
    id: "BAT-2026-003",
    batchNo: "AA-2603-HYD",
    productId: "PROD-003",
    productName: "Aashirvaad Shudh Chakki Superior MP Whole Wheat Atta (10kg)",
    mfgDate: "2026-06-01",
    expiryDate: "2026-09-01", // Expiring soon (<25 days)
    qtyRemaining: 95,
    warehouseId: "WH-001",
    warehouseCode: "WH-KATTEDAN",
    binCode: "A1-S2-B1",
    unitCost: 390,
    mrp: 495,
    status: "Expiring Soon"
  },
  {
    id: "BAT-2026-004",
    batchNo: "FR-2604-HYD",
    productId: "PROD-004",
    productName: "Freedom Refined Sunflower Oil 15L Commercial Tin",
    mfgDate: "2026-05-10",
    expiryDate: "2027-05-09",
    qtyRemaining: 65,
    warehouseId: "WH-001",
    warehouseCode: "WH-KATTEDAN",
    binCode: "B1-S1-B1",
    unitCost: 1780,
    mrp: 2150,
    status: "Good"
  },
  {
    id: "BAT-2026-005",
    batchNo: "FO-2605-HYD",
    productId: "PROD-005",
    productName: "Fortune Sunlite Refined Sunflower Oil (1L Pouch)",
    mfgDate: "2026-03-20",
    expiryDate: "2026-12-19",
    qtyRemaining: 180,
    warehouseId: "WH-001",
    warehouseCode: "WH-KATTEDAN",
    binCode: "C1-S1-B1",
    unitCost: 112,
    mrp: 145,
    status: "Good"
  },
  {
    id: "BAT-2026-006",
    batchNo: "VJ-2606-HYD",
    productId: "PROD-006",
    productName: "Vijaya Telangana Dairy Pure Ghee (1L Tin)",
    mfgDate: "2026-04-12",
    expiryDate: "2027-04-11",
    qtyRemaining: 55,
    warehouseId: "WH-002",
    warehouseCode: "WH-BEGUMBAZAR",
    binCode: "K-B1-B1",
    unitCost: 530,
    mrp: 680,
    status: "Good"
  },
  {
    id: "BAT-2026-007",
    batchNo: "TD-2607-HYD",
    productId: "PROD-007",
    productName: "Desi Toor Dal / Kandipappu Nizamabad Polished (1kg Pkt)",
    mfgDate: "2026-02-01",
    expiryDate: "2027-02-01",
    qtyRemaining: 130,
    warehouseId: "WH-001",
    warehouseCode: "WH-KATTEDAN",
    binCode: "A1-S1-B2",
    unitCost: 142,
    mrp: 185,
    status: "Good"
  },
  {
    id: "BAT-2026-008",
    batchNo: "WG-2608-HYD",
    productId: "PROD-008",
    productName: "Warangal Hot Teja Red Chilly Powder (500g Pkt)",
    mfgDate: "2026-03-01",
    expiryDate: "2027-03-01",
    qtyRemaining: 90,
    warehouseId: "WH-002",
    warehouseCode: "WH-BEGUMBAZAR",
    binCode: "K-A1-B1",
    unitCost: 165,
    mrp: 220,
    status: "Good"
  },
  {
    id: "BAT-2026-009",
    batchNo: "PR-2609-HYD",
    productId: "PROD-010",
    productName: "Priya Ginger Garlic Paste Commercial Pack (1kg Pouch)",
    mfgDate: "2026-05-01",
    expiryDate: "2026-11-01",
    qtyRemaining: 40,
    warehouseId: "WH-003",
    warehouseCode: "WH-KUKATPALLY",
    binCode: "D-A1-B1",
    unitCost: 115,
    mrp: 160,
    status: "Good"
  }
];
